export default __webpack_public_path__ + "images/AR.5d65aec.png";